export const QualificationListSortEnum = {
    QUALIFICATION: "qualification",
    QUALIFICATION_ASC: "name",
    QUALIFICATION_DESC: "-name",
    TYPE: "type",
    TYPE_ASC: "type",
    TYPE_DESC: "-type",
};
